import React from "react"
import styled from "styled-components"
import imgTwo from "../../../assets/images/book-library/img-2.png"
import authorIcon from "../../../assets/images/book-library/author-icon.png"
import { Button } from "../../reusableComponents/Button"
import { AiFillMail } from "@react-icons/all-files/ai/AiFillMail"
import { GiBlackBook } from "@react-icons/all-files/gi/GiBlackBook"
import { BsPersonLinesFill } from "@react-icons/all-files/bs/BsPersonLinesFill"

function Explore() {
  return (
    <MainContainer>
      <ColumnWrapper alignItems={"flex-start"} gap={"3rem"}>
        <ColumnWrapper alignItems={"flex-start"}>
          <Title>Explore Our Featured Authors and Books</Title>
          <Description>
            Dive into the world of literature with our curated selection of
            featured authors and their remarkable contributions. Find
            inspiration and discover new favorites
          </Description>
        </ColumnWrapper>
        <RowWrapper gap={"1.5rem"} alignItems={"flex-start"} mobileColumn>
          <ColumnWrapper alignItems={"flex-start"}>
            {" "}
            <CirclePadding>
            <GiBlackBook color="#111" size={40} />{" "}
            </CirclePadding>
            <SubTitle>Featured Books</SubTitle>{" "}
            <Description>
              Explore the books that highlight the best contributions from
              renowned authors.
            </Description>{" "}
          </ColumnWrapper>
          <ColumnWrapper alignItems={"flex-start"}>
            {" "}
            <CirclePadding>
            <IconWrapper><Image src={authorIcon} /></IconWrapper>
            </CirclePadding>
            <SubTitle>Featured Authors</SubTitle>{" "}
            <Description>
              Meet the authors shaping the iterary landscape with their unique insights.
            </Description>{" "}
          </ColumnWrapper>
        </RowWrapper>
        {/* <Button round="true" primary>
          Learn more
        </Button> */}
      </ColumnWrapper>
      <ImageWrapper>
        <Image src={imgTwo} />
      </ImageWrapper>
    </MainContainer>
  )
}

export default Explore

const MainContainer = styled.main`
  padding: 4rem calc((100vw - 1200px) / 2);
  width: 100%;
  height: auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  background: #eaf2f8;
  /* background: red; */

  @media screen and (max-width: 1249px) {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    box-sizing: border-box;
  }

  @media screen and (max-width: 767px) {
    height: auto;
    grid-template-columns: 1fr;
  }
`

const ColumnWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${({ gap }) => (gap ? gap : "1rem")};
  align-items: ${({ alignItems }) => (alignItems ? alignItems : "center")};
`
const RowWrapper = styled.div`
  display: flex;
  gap: ${({ gap }) => (gap ? gap : "1rem")};
  align-items: ${({ alignItems }) => (alignItems ? alignItems : "center")};

  @media screen and (max-width: 519px) {
    flex-direction: ${({mobileColumn}) => (mobileColumn ? "column" : "row")};
  }
`

const Br = styled.br`
  display: flex;
  @media screen and (max-width: 968px) {
    display: none;
  }
`

const Title = styled.h1`
  /* color: #fff; */
  color: ${props => props.theme.colors.accent7};
  font-size: 36px;
  text-align: flex-start;

  @media screen and (max-width: 767px) {
    font-size: 3rem;
    /* text-align: center; */
  }

  @media screen and (max-width: 600px) {
    font-size: 2rem;
  }
`

const SubTitle = styled.p`
  color: ${props => props.theme.colors.dark1};
  font-size: 26px;
  font-weight: bold;
  text-align: flex-start;

  @media screen and (max-width: 600px) {
    font-size: 18px;
  }
`

const Description = styled.p`
  /* color: #fff; */
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  text-align: flex-start;
  color: ${props => props.theme.colors.dark4};

  @media screen and (max-width: 767px) {
    font-size: 14px;
  }

`

const ImageWrapper = styled.div`
  width: 100%;
  height: 100%;
  /* background-color: #9691ff; */
  position: relative;
`

const IconWrapper = styled.div`
  width: 45px;
  height: 45px;
  /* background-color: #9691ff; */
  position: relative;
  /* background: red; */
`

const CirclePadding = styled.div`
  width: 70px;
  height: 70px;
  padding: .3rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #111;
  border-radius: 100%;
`

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  /* position: absolute;
  top: 0; */

  /* @media screen and (max-width: 1024px) {
    width: 57%;
    left: 21%;
  }

  @media screen and (max-width: 568px) {
    width: 100%;
    object-fit: contain;
    height: auto;
    left: 3%;
  } */
`
